<mat-tab-group>
  <mat-tab label="Regular Signature Matrix Templates">
    <mat-accordion [multi]="true">
      @for (property of getSignatureTypes(); track property; let idx = $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ convertSignatureTypeToName(property) }}</mat-panel-title>
            <mat-panel-description>{{ getTypeSummary(property) }}</mat-panel-description>
          </mat-expansion-panel-header>
          <app-signature-matrix-template-list [signatureType]="property" [idx]="idx"></app-signature-matrix-template-list>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-tab>
  <mat-tab label="Company Templates">
    <mat-accordion [multi]="true">
      @for (property of getCompanySignatureTypes(); track property; let idx = $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ property }}</mat-panel-title>
            <mat-panel-description>{{ getCustomTypeSummary(SignatureType.COMPANY, property) }}</mat-panel-description>
          </mat-expansion-panel-header>
          <app-signature-matrix-template-list
            [signatureType]="SignatureType.COMPANY"
            [customTypeName]="property"
            [customType]="true"
            [idx]="idx"
          ></app-signature-matrix-template-list>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-tab>
  <mat-tab label="Check Sheet Templates">
    <mat-accordion [multi]="true">
      @for (property of getCheckSheetSignatureTypes(); track property; let idx = $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ property }}</mat-panel-title>
            <mat-panel-description>{{ getCustomTypeSummary(SignatureType.CHECK_SHEET, property) }}</mat-panel-description>
          </mat-expansion-panel-header>
          <app-signature-matrix-template-list
            [signatureType]="SignatureType.CHECK_SHEET"
            [customTypeName]="property"
            [customType]="true"
            [idx]="idx"
          ></app-signature-matrix-template-list>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-tab>
</mat-tab-group>

<div class="signature-role-container">
  <app-signature-role></app-signature-role>
</div>
